import { useEffect, useState } from "react";

const links = [
  { href: "#serializing", label: "热门连载" },
  { href: "#updates", label: "今日更新" },
  { href: "#completed", label: "完结漫画" },
  { href: "#guide", label: "追更指南" },
  { href: "#faq", label: "常见问题" },
  { href: "#about", label: "关于我们" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 shadow-none ring-1 ring-background-200"
          : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 md:px-6" aria-label="主导航">
        <a
          href="#top"
          className="flex items-center gap-2 font-heading text-xl text-foreground-950"
          title="吹雪漫画网 首页"
        >
          <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-snowflake-line text-lg"></i>
          </span>
          吹雪漫画网
        </a>

        <div className="hidden items-center gap-1 md:flex">
          {links.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="whitespace-nowrap rounded-md px-3 py-2 text-sm text-foreground-700 transition hover:bg-primary-100 hover:text-primary-700"
            >
              {link.label}
            </a>
          ))}
        </div>

        <div className="flex items-center gap-2">
          <a
            href="#serializing"
            className="hidden whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition hover:bg-primary-600 sm:inline-flex"
          >
            开始追更
          </a>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            className="flex h-9 w-9 items-center justify-center rounded-md bg-background-100 text-foreground-800 md:hidden"
            aria-label="打开菜单"
            aria-expanded={open}
          >
            <i className={`text-lg ${open ? "ri-close-line" : "ri-menu-line"}`}></i>
          </button>
        </div>
      </nav>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 py-3 md:hidden">
          <div className="flex flex-col gap-1">
            {links.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="rounded-md px-3 py-2.5 text-sm text-foreground-700 transition hover:bg-primary-100 hover:text-primary-700"
              >
                {link.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}